<template>
  <div class="table-groups" :disabled="loading">
    <div v-for="(group, index1) in groups_fulled" :key="index1" class="group-item">
      <div class="group">{{ group.name }}</div>

      <div class="questions">
        <div v-for="(question, index2) in group.questions" :key="index2" class="question">
          <div v-if="question && question.label" class="body">{{ question.label }}</div>

          <div v-if="question && !question.label" class="body">{{ question.body }}</div>
          <div class="actions">
            <vbutton
              class="remove-button"
              color="transparent"
              type="icon"
              icon="icon-bin"
              @click="remove_connection(question.id)"
            />
          </div>
        </div>

        <div v-if="!group.questions.length" class="question">
          <div class="body empty">{{ $tr('vacancy.videoInterview.questions.empty') }}</div>

          <div class="actions">
            <vbutton
              class="remove-button"
              color="transparent"
              type="icon"
              icon="icon-bin"
              @click="delete_group_local(group.id)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'TableGroups',

  data() {
    return {
      loading: false
    };
  },

  computed: {
    ...mapGetters('vacancy_new/video_interview_groups', ['groups_fulled'])
  },

  methods: {
    ...mapMutations('vacancy_new/video_interview_groups', ['remove_connection']),

    ...mapActions('vacancy_new/video_interview_groups', ['delete_group']),

    delete_group_local(id) {
      this.loading = true;

      this.delete_group(id)
        .then(() => {
          this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text'));
        })
        .catch(() => {
          this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text'));
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-groups {
  border: 1px solid #d7d7d7;

  .group-item {
    border-bottom: 1px solid #d7d7d7;
    display: flex;
    align-items: stretch;

    .group {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      width: 250px;
      min-width: 250px;
      box-sizing: border-box;
      padding: 10px;
      border-right: 1px solid #d7d7d7;
      // white-space: nowrap;
      text-overflow: ellipsis;
    }

    .questions {
      flex-grow: 1;
      .question {
        display: flex;
        align-items: stretch;
        border-bottom: 1px solid #d7d7d7;
        .body {
          padding: 10px;
          flex-grow: 1;
          border-right: 1px solid #d7d7d7;
          &.empty {
            font-weight: 700;
          }
        }
        .actions {
          padding: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:last-of-type {
          border-bottom: none;
        }
      }
    }
    &:last-of-type {
      border-bottom: none;
    }
  }
}
</style>